import { View } from "@Engage.Data/modules/view/View";
export class MeterViewQualifier {
    constructor() {
        this.key = "MeterView";
    }
    process() {
        // +1 because qualifiers run before incrementConversationCount().
        // The paywall should evaluate the count including the current page view.
        return String(View.getTotalArticleCount() + 1);
    }
}
